













import Vue from 'vue';
import {Component} from 'vue-property-decorator';
import {Getter, Mutation} from 'vuex-class';
import {GetterTypes as GetterTypesSnackbar, MutationTypes as MutationTypesSnackbar} from '../../store/snackbar/types';

const namespace: string = 'snackbar';

@Component
export default class Snackbar extends Vue {
  @Getter(GetterTypesSnackbar.GET_MESSAGE, {namespace}) message!: string;
  @Getter(GetterTypesSnackbar.GET_COLOR, {namespace}) color!: string;
  @Getter(GetterTypesSnackbar.GET_SHOW, {namespace}) getShow!: boolean;
  @Mutation(MutationTypesSnackbar.SET_SHOW, {namespace}) setShow!: (show: boolean) => void;

  private timeoutId: number | null = null;

  get show(): boolean {
    return this.getShow;
  }

  set show(show: boolean) {
    this.setShow(show);
  }
}
